import { render, staticRenderFns } from "./TabContent.vue?vue&type=template&id=cf1f8288"
import script from "./TabContent.vue?vue&type=script&lang=js"
export * from "./TabContent.vue?vue&type=script&lang=js"
import style0 from "./TabContent.vue?vue&type=style&index=0&id=cf1f8288&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports